/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

const className = 'buffer-tab';

abstract class BufferTabView<T extends Backbone.Model> extends Backbone.View<T> {
  static className: string;

  static initClass(): void {
    this.className = className;
    this.prototype.className = className;
    this.prototype.attributes = {
      tabindex: 2,
    };
  }

  abstract removeAsync(afterRemove: () => void): BufferTabView<T>;

  afterAttach(): void {
    // no-op
  }
}
BufferTabView.initClass();

export default BufferTabView;
